import { Button as MuiButton } from '@mui/material'
import { styled } from '@mui/system'

const OutlinedButton = styled(MuiButton)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: 8,
  color: theme.palette.basic[100],
  borderColor: theme.palette.border.main,
  '&:hover': {
    borderColor: theme.palette.basic[100],
  },
  fontSize: 14,
}))

export default function OutlinedWhiteButton({ onClick, label = '', ...rest }) {
  return (
    <OutlinedButton
      variant="outlined"
      sx={{ mr: 2 }}
      onClick={onClick}
      {...rest}
    >
      {label}
    </OutlinedButton>
  )
}
